import { Currency } from "../Domain/Currency";
import { CurrencyUi } from "./CurrencyUi";

export const currencyToCurrencyUiMap: {
  [TKey in Currency]: CurrencyUi;
} = {
  [Currency.EUR]: CurrencyUi.EUR,
  [Currency.GBP]: CurrencyUi.GBP,
};
